<template>
  <div id="sidebar">
    <h4>Buscar datos</h4>
    <form role="form" class="form-inline" @submit.prevent="processForm">
      <div class="input-group">
        <input type="text" aria-required="true" name="search-input" class="form-control" placeholder="Palabra clave" v-model="searchValue">
        <span class="input-group-btn">
          <button type="submit" id="widget-subscribe-submit-button" class="btn btn-primary"><i class="fa fa-paper-plane"></i></button>
        </span>
      </div>
    </form>
    <hr>
    <loading v-if="isLoading"></loading>
    <div class="accordion fancy radius clean" v-if="!isLoading">
      <nav-item v-for="section in sections" :slug="section.slug" :title="section.title" :icon="section.icon" :categories="section.topics" :key="section.title"></nav-item>
    </div>
  </div>
</template>

<script>
  /* global datos_abiertos  */
  import axios from 'axios';

  import NavItem from './NavItem';
  import Loading from './Loading';

  export default {
    name: 'sidebar',
    data() {
      return {
        apiUrl: '',
        sections: [],
        errors: [],
        isLoading: true,
        searchValue: '',
      };
    },
    components: {
      NavItem,
      Loading,
    },
    methods: {
      processForm() {
        this.$router.push(
          {
            name: 'home',
            params: {
              type: 'search', slug: this.searchValue,
            },
          });
        this.searchValue = '';
      },
    },
    created() {
      this.apiUrl = datos_abiertos.api_url;
      axios.get(`${this.apiUrl}/wp-json/datos-abiertos/v1/sidebar`).then((response) => {
        this.isLoading = false;
        if (response.status === 200) {
          this.sections = response.data;
//          console.log(this.sections);
        }
      }).catch((e) => {
        this.error = e;
        console.log(this.error);
      });
    },
  };
</script>
<style>
  #sidebar .list-group-item {
    position: relative !important;
    display: block !important;
    padding: 10px 15px !important;
    margin-bottom: -1px !important;
    background-color: #fff !important;
    border: 1px solid #ddd !important;
    font-size: 15px !important;
    color: #555555 !important;
    font-weight: 700 !important;
    text-decoration: underline;
  }

  #sidebar .form-inline {
    margin-bottom: 15px;
  }

  #sidebar .accordion {
    margin-top: 15px;
  }

  .list-group-item > .badge {
    float: right;
  }

  .badge {
    margin-right: 10px;
  }

  .badge {
    display: inline-block;
    min-width: 10px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    line-height: 1;
    vertical-align: baseline;
    white-space: nowrap;
    text-align: center;
    background-color: #777;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?7e5b1268